export enum Paths {
  HOME = '/',
  ADMIN = '/admin',
  ACHIEVEMENTS = '/achievements',
  ACTIVITY_PLANNING = '/activity-planning',
  ACTIVITY_EDITING = '/activity/:id',
  REPLAN_ACTIVITES = '/replan-activities',
  CREATE_PASSKEY = '/create-passkey',
  DAILY_LOG = '/daily-log',
  ENABLE_NOTIFICATIONS = '/enable-notifications',
  ENABLE_TRACKING = '/enable-tracking',
  FORGOT_PASSWORD = '/forgot-password',
  LET_GET_STARTED = '/let-get-started',
  LOGIN = '/login',
  LOGOUT = '/logout',
  MESSAGE = '/message/:id',
  MESSAGES = '/messages',
  PERMISSION_REQUIRED = '/permission-required',
  REGISTER = '/register',
  RESOURCES = '/resources',
  STUDY_QUESTIONS = '/study-questions',
  MOTIVATION_QUESTIONS = '/motivation-questions',
  TUTORIAL = '/tutorial',
  USER_INFO = '/user-info',
  USER_PROFILE = '/profile',
  WEEKLY_LOG = '/weekly-log',
  WELCOME = '/welcome'
}
